import { ReportsFeatureGuard } from './reports-feature.guard';

export const guards = [ReportsFeatureGuard];

export * from './reports-feature.guard';
